import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class HHTableHeader extends Component {

  static Layout = [
    { column: "meterType", name: "Meter Type" },
    { column: "meterReference", width: 2, name: "Meter Reference" },
    { column: "supplyAddress", width: 2, name: "Supply Address" },
    { column: "siteID", width: 2, name: "Site ID" },
    { column: "date", width: 1, name: "Date"},
    { column: "dayOfWeek", width: 1, name: "Day Of Week" },
    { column: "dataType", width: 2, name:"Data Type" },
    { column: "totalUsage", width: 2, name: "Total Usage" },
    { column: "md", width: 1 },
    { column: "estimatedCost", width: 1, name: "Estimated Cost" },
    // { column: "empty", width: 2 }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={HHTableHeader.Layout}/>
    )
  }

}